import type { ReactElement, ReactNode } from 'react';
import { PRODUCT_NAME } from '../../constants';

interface AppHeaderProps {
  /** Primary navigation (e.g. Requests / Purchase orders / Wells / Vendors). */
  navSlot?: ReactNode;
  endSlot?: ReactNode;
}

export function AppHeader({ navSlot, endSlot }: AppHeaderProps): ReactElement {
  return (
    <header className="app-header">
      <div className="brand-lockup" aria-label={PRODUCT_NAME}>
        <span className="brand-mark">P-Flo</span>
        <div className="brand-text">
          <h1 className="brand-title">{PRODUCT_NAME}</h1>
        </div>
      </div>
      {navSlot}
      {endSlot}
    </header>
  );
}
